import _ from "lodash";
import api from "../../services/apiEndpoints";
import moment from "moment";
import $ from "jquery";

export const servicesMixin = {
    methods: {
        newMakeServiceCategoryMapping(user) {
            let userId = user.user.id;
            let serviceCategoryMapping = {};
            _.each(user.services, function (services, categoryId) {
                if (!services.length) {
                    return;
                }
                services.forEach(function (service) {
                    serviceCategoryMapping[service.id] = categoryId;
                });
            });
            this.newServiceCategoryMapping[userId] = serviceCategoryMapping;
            this.numberOfDataFetched++;
            this.newMakeEvents();
        },

        newMakeColorCategoryMapping(user) {
            let userId = user.user.id;
            let colorCategoryMapping = {};
            user.service_categories.forEach((category) => {
                let targetColor = _.find(this.newColors, function (colorObject) {
                    return colorObject.id == category.color_id;
                });
                if (typeof targetColor == "undefined") {
                    colorCategoryMapping[category.id] = null;
                    return;
                }
                colorCategoryMapping[category.id] = "#" + targetColor.code;
            });
            this.newColorCategoryMapping[userId] = colorCategoryMapping;
            this.numberOfDataFetched++;
            this.newMakeEvents();
        },

        onClientWidgetServiceSelected() {
            this.getClientWidgetSettings();
        },

        getClientWidgetSettings() {
            let data = {
                client_id: this.user.id,
                service_id: this.clientWidgetSelectedService,
                days: 14,
            };

            if (this.clientWidgetSettings && this.clientWidgetSettings.stylist_id) {
                data.stylist_id = this.clientWidgetSettings.stylist_id;
            }

            this.$http.post(api.actions.get_next_days_available_slots, data, { noError: 1 }).then(
                function (res) {
                    if (res.data.error == false) {
                        if (!this.clientWidgetSelectedService) {
                            this.clientWidgetRegularService = res.data.service_id;
                        }

                        this.clientWidgetSettings.stylist_id = res.data.stylist_id;
                        this.clientWidgetSettings.stylist_name = res.data.stylist_name;
                        this.clientWidgetSettings.stylist_avatar = res.data.stylist_avatar;
                        this.clientWidgetSelectedService = res.data.service_id;
                        this.clientWidgetSettings.stylist_policy = res.data.profile.policy;
                        this.clientWidgetSettings.stylist_currency = res.data.profile.currency
                            ? res.data.profile.currency
                            : "USD";
                        this.clientWidgetDays = [];

                        for (let day in res.data.next_days_slots) {
                            if (
                                res.data.next_days_slots[day].length > 0 &&
                                this.clientWidgetDays.length === 0 &&
                                this.clientWidgetDays.length < 3
                            ) {
                                this.clientWidgetDays.push({
                                    date: moment(day).format("MMM Do"),
                                    dateUnformatted: day,
                                    slots: res.data.next_days_slots[day],
                                });
                            }
                        }

                        //get the stylist services
                        this.$http.get(api.actions.get_stylist_services + "?stylist_id=" + res.data.stylist_id).then(
                            function (response) {
                                if (typeof response.data.services != "undefined") {
                                    let services = _.filter(response.data.services, (srv) => {
                                        return srv.active == 1;
                                    });
                                    this.clientWidgetServices = [];
                                    services.forEach((el) => {
                                        let serviceName =
                                            this.clientWidgetRegularService == el.id ? el.name + " (regular)" : el.name;
                                        this.clientWidgetServices.push({
                                            label: serviceName,
                                            value: el.id,
                                        });

                                        if (this.clientWidgetSelectedService == el.id) {
                                            this.clientWidgetServiceDuration = el.duration;
                                            this.clientWidgetServicePrice = el.price;
                                        }
                                    });
                                }
                            }.bind(this),
                        );
                    } else {
                        this.$router.push("/app/stylists");
                    }
                }.bind(this),
            );
        },

        saveService(service) {
            let data = {
                duration: service.duration,
                service_price: service.price,
                service_id: service.id,
                service_quantity: service.qty,
                appointment_id: this.selected_event.id,
            };
            let index = this.selectedServicesArray.findIndex((x) => x.service_id === service.id);

            this.$http.post(api.actions.save_appointment_service, data).then(
                function () {
                    this.addServiceModal = false;
                    this.selectedServicesArray[index].duration = service.duration;
                    this.selectedServicesArray[index].price = service.price;
                    this.selectedServicesArray[index].service_price = service.price;
                    this.selectedServicesArray[index].service_quantity = parseInt(service.qty);

                    this.updateSelectedServices();
                }.bind(this),
            );
        },

        addServiceApp() {
            this.addServiceModal = true;
        },

        saveServices() {
            this.updateSelectedServices();

            this.editServices = false;
            this.addServiceModal = false;
            this.calculateServiceTotals();
        },

        updateSelectedServices() {
            this.newSelectedServices = [];
            this.newTotalDurationServices = 0;
            let self = this;

            this.selectedServicesArray.forEach((service) => {
                let image = "";
                let description = "";
                let user_id = "";

                self.appointment_details.category_services.forEach(function (cat) {
                    cat.services.forEach(function (serv) {
                        if (service.service_id == serv.id) {
                            image = serv.image;
                            description = serv.description;
                            user_id = serv.user_id;
                        }
                    });
                });

                let data = {
                    categoryName: "",
                    duration: service.duration,
                    featured: 1,
                    id: service.service_id,
                    name: service.service_name,
                    price: service.service_price,
                    price_and_up: 0,
                    is_product: service.is_product,
                    qty: service.service_quantity,
                    default_duration: service.default_duration,
                    default_price: service.default_price,
                    selected: true,
                    image: image,
                    description: description,
                    user_id: service.user_id,
                };
                if (service.selected) {
                    this.newTotalDurationServices =
                        parseInt(this.newTotalDurationServices) + parseInt(service.duration);
                    this.newSelectedServices.push(data);
                }
                // Changed the service.id part with service.service_id to make things work ...
                this.selectedServiceQty[service.service_id] = service.service_quantity;
            });
        },

        newSaveService(closeModal = false, resetQty = false) {
            if (closeModal) {
                $("#add-service-modal").slideUp();
            }

            let existingQty = {};

            if (this.newSelectedServices.length > 0) {
                this.newSelectedServices.forEach((service) => {
                    if (service.selected) {
                        existingQty[service.id] = parseInt(service.qty);
                    }
                });
            }

            this.newTotalCostServices = 0;
            this.newSelectedServices = [];
            this.newShowSelectedServices = false;
            this.newSelectedServicesString = "";

            let targetServices = [];
            this.newServicesArray.forEach((service) => {
                if (service.selected) {
                    let newService = _.clone(service);
                    newService.qty = existingQty[newService.id] ? existingQty[newService.id] : 1;
                    targetServices.push(newService);
                } else if (resetQty == true) {
                    this.selectedServiceQty[service.id] = 1;
                }
            });

            if (!Object.keys(targetServices).length) {
                return;
            }
            this.newSelectedServices = targetServices;
            //making selected services in string
            let allServices;
            this.newSelectedServices.forEach((element) => {
                if (allServices) {
                    allServices = allServices + ", " + element.name;
                } else {
                    allServices = element.name;
                }
                this.newSelectedServicesString = allServices;
            });

            //here starts logic for total cost
            let totalCost;
            this.newSelectedServices.forEach((element) => {
                const serviceQuantity = this.selectedServiceQty[element.id];

                if (totalCost) {
                    totalCost = totalCost + element.price * serviceQuantity;
                } else {
                    totalCost = element.price * serviceQuantity;
                }
                this.newTotalCostServices = totalCost;
            });
            //total cost logic ends

            //logic for duration

            let totalDuration;
            this.newSelectedServices.forEach((element) => {
                if (totalDuration) {
                    totalDuration = totalDuration + element.duration;
                } else {
                    totalDuration = element.duration;
                }
                this.newTotalDurationServices = totalDuration;
            });

            if (this.newSelectedServices.length) {
                this.newShowSelectedServices = true;
            } else {
                this.newShowSelectedServices = false;
            }

            if (this.newTotalCostServices > 0) {
                this.newShowTotalCost = true;
            } else {
                this.newShowTotalCost = false;
            }

            if (this.newTotalDurationServices > 0) {
                this.newShowTotalDuration = true;
            } else {
                this.newShowTotalDuration = false;
            }

            //enable save button
            if (this.newSelectedServices.length) {
                this.newDisableSaveServices = false;
            } else {
                this.newDisableSaveServices = true;
            }

            this.newManageSaveAppointmentButton();
            this.calculateServiceTotals();
        },

        calculateServiceTotals() {
            this.newTotalCostServices = 0;
            this.newTotalDurationServices = 0;
            this.newSelectedServices.forEach((service) => {
                // service.qty seems to be undefined so we have to rely on this.selectedServiceQty[service.id]
                let qty = service.qty
                    ? parseInt(service.qty)
                    : this.selectedServiceQty[service.id]
                      ? this.selectedServiceQty[service.id]
                      : 1;

                this.newTotalCostServices += (service.default_price ? service.default_price : service.price) * qty;
                this.newTotalDurationServices +=
                    (service.default_duration ? service.default_duration : service.duration) * qty;
                // Warning: Prone to errors
                if (typeof this.selectedServiceQty[service.id] !== "number") {
                    this.selectedServiceQty[service.id] = qty;
                }
            });

            this.appointment_details.total_price = this.newTotalCostServices;
            if (!this.appointment_details.details) {
                this.appointment_details.details = { total_payments: 0 };
            }
            this.amount =
                parseFloat(this.appointment_details.total_price) -
                parseFloat(
                    this.appointment_details.details.total_payments
                        ? this.appointment_details.details.total_payments
                        : 0,
                );
        },

        newMakeListServices() {
            //turn selected as true for those services in array
            let selected_service_ids = _.map(this.newSelectedServices, (el) => {
                return el.id;
            });

            let servicesArray = [];

            _.each(this.newClientServices[this.newCurrentStylistId], function (category, categoryName) {
                if (category.length) {
                    category.forEach(function (element) {
                        let serviceObject = {
                            name: element.name,
                            price: element.price,
                            selected: false,
                            id: element.id,
                            user_id: element.user_id,
                            duration: element.duration,
                            categoryName: categoryName,
                            price_and_up: element.price_and_up,
                            featured: element.featured,
                            is_product: element.is_product,
                            qty: element.qty,
                        };

                        if (selected_service_ids.indexOf(element.id) != -1) {
                            serviceObject.selected = true;
                        }
                        servicesArray.push(serviceObject);
                    });
                }
            });

            //make feature ones come at the top in alphabetica order
            var featuredServices = servicesArray.filter(function (serv) {
                return serv.featured;
            });
            //sort them into alphabetical order
            // descending order
            featuredServices.sort(function (serv1, serv2) {
                if (serv1.name < serv2.name) {
                    return -1;
                }
                if (serv2.name < serv1.name) {
                    return 1;
                }
                return 0;
            });

            var unfeaturedServices = servicesArray.filter(function (serv) {
                return !serv.featured;
            });
            this.newServicesArray = featuredServices.concat(unfeaturedServices);

            this.newServicesArray = _.uniqBy(this.newServicesArray, function (el) {
                return el.id;
            });

            this.newFillteredService = this.newServicesArray.slice();
            this.newResultQuery();
        },

        newAddServiceHere(service) {
            $("#add-service-modal").slideUp();
            // servicesArray
            this.newServicesArray.forEach(function (element) {
                if (element.id !== service.id) {
                    element.selected = false;
                } else {
                    element.selected = true;
                }
            });

            this.newShowSelectedServices = true;
            this.newSelectedServicesString = service.name;
            this.newSelectedServices = [service];
            this.newTotalCostServices = service.price;
            this.newTotalDurationServices = service.duration;
            this.newShowTotalCost = true;
            this.newShowTotalDuration = true;
            this.newManageSaveAppointmentButton();
        },

        newResultQuery() {
            this.hasProducts = false;
            this.hasServices = false;

            this.newServicesArray = this.newFillteredService.slice();
            if (this.newSearchQuery) {
                this.newServicesArray = this.newServicesArray.filter((item) => {
                    return this.newSearchQuery
                        .toLowerCase()
                        .split(" ")
                        .every((v) => item.name.toLowerCase().includes(v));
                });
            }
            this.newServicesArray.forEach((item) => {
                if (item.is_product === 1) {
                    this.hasProducts = true;
                }

                if (item.is_product === 0) {
                    this.hasServices = true;
                }
            });
        },

        changeDuration(increase) {
            if (increase) {
                this.newTotalDurationServices = this.newTotalDurationServices + 10;
                return;
            }
            //you can't have duration in minus
            if (this.newTotalDurationServices > 0) {
                this.newTotalDurationServices = this.newTotalDurationServices - 10;
            }
        },

        deSelectService(index) {
            this.newSelectedServices.splice(index, 1);
            this.selectedServicesArray[index].selected = 0;
            this.calculateServiceTotals();
        },

        setServiceQty(event, service_id) {
            const qty = Number(event.target.value);

            this.selectedServiceQty[service_id] = qty;

            let currentService = _.filter(this.newServicesArray, { id: service_id });

            this.newSelectedServices.forEach((service) => {
                if (service.id === service_id) {
                    service.qty = qty;

                    if (currentService.length > 0) {
                        currentService = currentService[0];
                        service.default_duration = currentService.duration;
                        service.duration = qty * currentService.duration;
                        service.default_price = currentService.price;
                        service.price = qty * currentService.price;
                    } else {
                        service.duration = qty * service.default_duration;
                        service.price = qty * service.default_price;
                    }
                }
            });

            this.calculateServiceTotals();
        },

        getServicesQty() {
            let response = {};

            this.newSelectedServices.forEach((service) => {
                let duration =
                    this.bookData.id == 0
                        ? service.qty * (service.default_duration ? service.default_duration : service.duration)
                        : service.duration;
                let price =
                    this.bookData.id == 0
                        ? service.qty * (service.default_price ? service.default_price : service.price)
                        : service.price;

                response[service.id] = {
                    quantity: service.qty,
                    duration: duration,
                    price: price,
                };
            });

            return response;
        },

        handleSubmitSaveService() {
            // Reset errors
            this.addServiceFormObjError = {};

            // Basic validation
            if (!this.addServiceFormObj.name) this.addServiceFormObjError.name = true;
            if (!this.addServiceFormObj.price) this.addServiceFormObjError.price = true;
            if (!this.isAddingProduct && !this.addServiceFormObj.duration) this.addServiceFormObjError.duration = true;

            // If there are errors, stop and show a message
            if (Object.keys(this.addServiceFormObjError).length) {
                messages.errorMessage(messages.GLOBAL_MESSAGES.REQUIRED_FIELDS);
                return;
            }

            const payload = {
                name: this.addServiceFormObj.name,
                price: this.addServiceFormObj.price,
                duration: this.addServiceFormObj.duration,
                active: 1,
                is_product: this.isAddingProduct ? 1 : 0,
                user_id: this.newCurrentStylistId,
                friday: 1,
                monday: 1,
                price_and_up: 1,
                saturday: 1,
                sunday: 1,
                thursday: 1,
                tuesday: 1,
                wednesday: 1,
            };

            this.$http.post(api.actions.save_service, payload).then((response) => {
                if (!response.data.error) {
                    this.newGetServices({ user: { id: this.newCurrentStylistId } });
                    this.displayNewServicesForm = false;

                    // Reset form
                    this.addServiceFormObj = {
                        name: "",
                        price: null,
                        duration: "",
                    };

                    messages.successMessage(messages.GLOBAL_MESSAGES.GENERAL_SAVE);
                }
            });
        },

        toggleAddNewServiceForm(isProduct) {
            this.isAddingProduct = isProduct;
            this.displayNewServicesForm = !this.displayNewServicesForm;

            this.addServiceFormObjError.name = false;
            this.addServiceFormObjError.price = false;
            this.addServiceFormObjError.duration = false;
        },

        processServicesDisplay(services) {
            if (!services) {
                return "";
            }

            return services.replace(/;/g, ", ");
        },

        getProductImage(image_url, user_id = false) {
            if (!image_url) {
                return "";
            }
            return (
                api.API_ENDPOINT + "/uploads/images/services/" + (!user_id ? this.user.id : user_id) + "/" + image_url
            );
        },

        newGetServices(user) {
            let userId = user.user.id;
            this.newClientServices[userId] = {};

            this.$http.get(api.actions.get_stylist_services + "?stylist_id=" + userId).then(
                function (response) {
                    if (typeof response.data.services != "undefined") {
                        response.data.services.forEach((serv) => {
                            let targetCategory = _.find(response.data.category_services, function (category) {
                                return category.category_id == serv.category_id;
                            });
                            if (typeof targetCategory == "undefined") {
                                return;
                            }
                            if (typeof this.newClientServices[userId][targetCategory.category] == "undefined") {
                                this.newClientServices[userId][targetCategory.category] = [];
                            }
                            this.newClientServices[userId][targetCategory.category].push(serv);
                            // set default quantity value for selected services be 1
                            // make sure you dont override existing selected services quantity
                            // tried to set the selectedServiceQty to serv.service_quantity but there's no service_quantity coming from backend ...
                            if (typeof this.selectedServiceQty[serv.id] !== "number") {
                                this.selectedServiceQty[serv.id] = 1;
                            }
                        });
                    }
                    this.numberOfDataFetched++;
                    this.newMakeEvents();
                    // BUILD LIST AFTER DATA ARRIVES
                    this.newMakeListServices();
                }.bind(this),
                function () {
                    return false;
                },
            );
        },
        onSelectedService() {
            $("#add-service-modal").slideUp();
        },
    },
};
